import { FightPlayer, Spell } from 'web/data/models'
import { CooldownResolver, DecoratingCooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { GENERATED_IDS } from './generated-ids'

type SpellResolverMap = { [spellId: string]: CooldownResolver }

const { __SPELL_ID, __TALENT_ID, __MODIFIER_ID } = GENERATED_IDS

export const SPELL_RESOLVERS: SpellResolverMap = {

    [__SPELL_ID.DRUID.RESTO.TRANQ]: (spell: Spell, fightPlayer: FightPlayer) => {
        let cd = spell.cooldown

        if (spell.id === __SPELL_ID.DRUID.RESTO.TRANQ) {
            if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.INNER_PEACE)) {
                cd = cd - 60
            }
        }

        return cd
    },

}

export const GENERIC_RESOLVERS: { [key: string]: DecoratingCooldownResolver } = {

    [__MODIFIER_ID.CELEST_SPIRIT]: (spell: Spell, fightPlayer: FightPlayer, cooldown: number) => {

        if ([__SPELL_ID.DRUID.RESTO.CONVOKE, __SPELL_ID.DRUID.BALANCE.CONVOKE,
        __SPELL_ID.DRUID.FERAL.CONVOKE, __SPELL_ID.DRUID.GUARDIAN.CONVOKE]
            .includes(spell.id) === false) {

            return cooldown
        }

        const spellIsAffected = spell.affectedByModifierIds.includes(__MODIFIER_ID.CELEST_SPIRIT)
        const playerHasMod = fightPlayer.modifierIds.includes(__MODIFIER_ID.CELEST_SPIRIT)

        const applyMod = spellIsAffected && playerHasMod

        if (applyMod === false) {
            return cooldown
        }

        // Convoke is 60s with legendary
        return 60
    },

    /**
     * Not used, but keeping it as a reference.
     *
     * NOTICE: Trust nothing in here, I have no idea what any of this
     * is supposed to do.
     */
    VOP_R3: (spell: Spell, fightPlayer: FightPlayer, cooldown: number) => {
        const spellIsAffected = spell.affectedByModifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const playerHasMod = fightPlayer.modifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const applyMod = spellIsAffected && playerHasMod

        if (applyMod === false) {
            return cooldown
        }

        // VOP R3 takes off roughly 77% (23% reduction)
        return Math.ceil(cooldown * 0.77)
    }

}
